import { IPromoDetails } from '../../types/promos/promoDetails';
import { IPromoItem } from '../../types/promos/promos';
import { IApplicationState } from '../../types/redux';

export const selectPromoById =
  (id: string) =>
  (state: IApplicationState): IPromoItem =>
    state.promos.previewById[id];

export const selectPromoDetailsById =
  (id: string) =>
  (state: IApplicationState): IPromoDetails =>
    state.promos.detailsById[id];
